import React from 'react'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import * as FiIcons from 'react-icons/fi'
import SafeIcon from '../ui/SafeIcon'

const { FiStar, FiMapPin, FiAward } = FiIcons

function SupplierSection() {
  const { t } = useTranslation()

  const suppliers = [
    { name: 'TechPro Manufacturing', location: 'Shenzhen, China', rating: 4.9, years: 8, products: 2500, image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=400&h=300&fit=crop', badge: 'Gold' },
    { name: 'Fashion Textile Co.', location: 'Guangzhou, China', rating: 4.8, years: 12, products: 5000, image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=400&h=300&fit=crop', badge: 'Gold' },
    { name: 'Home Goods Factory', location: 'Ningbo, China', rating: 4.7, years: 6, products: 1800, image: 'https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=400&h=300&fit=crop', badge: 'Silver' },
    { name: 'Smart Electronics Ltd.', location: 'Shenzhen, China', rating: 4.9, years: 10, products: 3200, image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=400&h=300&fit=crop', badge: 'Gold' }
  ]

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center mb-8">
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-2">
              {t('suppliers.title')}
            </h2>
            <p className="text-gray-600">
              {t('suppliers.subtitle')}
            </p>
          </div>
          <button className="text-orange-600 hover:text-orange-700 font-medium">
            {t('suppliers.viewAll')} →
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {suppliers.map((supplier, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer group"
            >
              {/* Factory Image */}
              <div className="relative h-40 overflow-hidden">
                <img src={supplier.image} alt={supplier.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" />
                <div className={`absolute top-2 right-2 px-2 py-1 rounded text-xs font-bold text-white ${supplier.badge === 'Gold' ? 'bg-yellow-500' : 'bg-gray-400'}`}>
                  <SafeIcon icon={FiAward} className="inline w-3 h-3 mr-1" />
                  {supplier.badge}
                </div>
              </div>

              {/* Supplier Info */}
              <div className="p-4">
                <h3 className="font-bold text-gray-900 mb-2 group-hover:text-orange-600 transition-colors">
                  {supplier.name}
                </h3>
                <div className="flex items-center text-sm text-gray-600 mb-2">
                  <SafeIcon icon={FiMapPin} className="w-4 h-4 mr-1" />
                  {supplier.location}
                </div>
                <div className="flex items-center mb-3">
                  <div className="flex items-center text-yellow-500">
                    <SafeIcon icon={FiStar} className="w-4 h-4 fill-current" />
                    <span className="ml-1 text-sm font-medium text-gray-900">
                      {supplier.rating}
                    </span>
                  </div>
                  <span className="mx-2 text-gray-300">|</span>
                  <span className="text-sm text-gray-600">{supplier.years} {t('suppliers.years')}</span>
                </div>
                <div className="text-sm text-gray-600">
                  {supplier.products.toLocaleString()} {t('suppliers.products')}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default SupplierSection